export enum ModalResponse {
    CLICK_NO = 'no',
    CLICK_YES = 'yes',
    CLICK_REMOVE_FORBIDDEN = 'removeForbidden'
}